// Karşılaştırmalar: bugün/dün, sürüm, kapasite. Az örnekte ya da ±%15 içinde fark kesin gösterilmez.
import { useEffect, useState } from 'react';
import { ownerApi } from '../ownerApi';
import { fmtMs, fmtNum } from './perfFormat';

const V = { daha_yavas: ['Daha yavaş', 'text-rose-700'], daha_hizli: ['Daha hızlı', 'text-emerald-700'], belirsiz: ['Belirgin fark yok (±%15 içinde)', 'text-slate-600'],
  yetersiz_ornek: ['Yetersiz örnek – kesin değil', 'text-amber-700'], tek_surum: ['Karşılaştırılacak ikinci sürüm yok', 'text-slate-500'], tek_kapasite: ['Karşılaştırılacak ikinci kapasite yok', 'text-slate-500'] };

const Block = ({ title, d, testId, extra }) => (
  <div className="rounded-xl border border-slate-200 bg-white p-4" data-testid={testId}>
    <div className="mb-2 flex items-center justify-between"><p className="font-semibold text-slate-900">{title}</p><span className={`text-xs font-semibold ${V[d.verdict]?.[1]}`}>{V[d.verdict]?.[0]}</span></div>
    <table className="w-full text-sm"><tbody>{d.rows.map(r => (
      <tr key={r.label} className="border-t border-slate-100"><td className="py-1 pr-2 font-mono text-xs">{r.label}</td><td className="text-right tabular-nums">{fmtNum(r.count)}</td>
        <td className="text-right tabular-nums">P50 {fmtMs(r.p50)}</td><td className="text-right tabular-nums">P95 {fmtMs(r.p95)}</td></tr>))}
      {!d.rows.length && <tr><td className="py-2 text-xs text-slate-500">Veri yok</td></tr>}</tbody></table>
    {extra && <p className="mt-2 text-xs text-slate-500">{extra}</p>}
  </div>
);

export const PerfCompare = () => {
  const [d, setD] = useState(null);
  useEffect(() => { ownerApi.get('/platform-owner/perf/compare').then(r => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  return (
    <div className="space-y-2" data-testid="perf-compare">
      <div className="grid gap-3 xl:grid-cols-3">
        <Block title="Bugün / dün" d={d.day} testId="perf-compare-day" />
        <Block title="Sürüm karşılaştırması (30 gün)" d={d.versions} testId="perf-compare-version" />
        <Block title="Kapasite (CPU/RAM) öncesi / sonrası" d={d.capacity} testId="perf-compare-capacity" extra={d.capacity.unknown_hours ? `${d.capacity.unknown_hours} saatlik özet kapasite bilgisi olmadan kaydedildi (bilinmiyor).` : null} />
      </div>
      <p className="text-xs text-slate-400">{d.note}</p>
    </div>
  );
};
